import type { IconProps } from '../types/IconProps.ts';
export const Braces: IconProps = {
    name: 'Braces',
    children: [
        `<path d="M16 3h1a2 2 0 0 1 2 2v4.76a2 2 0 0 0 1.1 1.8l.54.26a.2.2 0 0 1 0 .36l-.53.27A2 2 0 0 0 19 14.24V19a2 2 0 0 1-2 2h-1M8 21H7a2 2 0 0 1-2-2v-4.76a2 2 0 0 0-1.1-1.8l-.54-.26a.2.2 0 0 1 0-.36l.53-.27A2 2 0 0 0 5 9.76V5c0-1.1.9-2 2-2h1" />`,
    ]
};